export default __webpack_public_path__ + "static/media/v1.062608b1.png";